import { useState, useCallback } from 'react';

import { WorkflowSteps } from '../../../../../../tracking/use-workflow-tracking';

const STEP_ID = 'shipment_volume_and_onboarding_timeline';

/**
 * @param {(step: string, metadata?: object) => void} trackWorkflow
 * @returns {{
 *   shipmentVolume: string,
 *   timeline: string,
 *   isComplete: boolean,
 *   isEditing: boolean,
 *   isValid: boolean,
 *   onShipmentVolumeChange: (value: string) => void,
 *   onTimelineChange: (value: string) => void,
 *   onContinue: () => void,
 *   onEdit: () => void
 * }}
 */
export const useShipmentVolumeTimelineStep = (trackWorkflow) => {
  const [shipmentVolume, setShipmentVolume] = useState('');
  const [timeline, setTimeline] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const isValid = shipmentVolume !== '' && timeline !== '';

  const onContinue = useCallback(() => {
    setIsComplete(true);
    setIsEditing(false);
    trackWorkflow(WorkflowSteps.CONTINUE, { stepId: STEP_ID });
  }, [trackWorkflow]);

  const onEdit = useCallback(() => {
    setIsEditing(true);
  }, []);

  return {
    shipmentVolume,
    timeline,
    isComplete,
    isEditing,
    isValid,
    onShipmentVolumeChange: setShipmentVolume,
    onTimelineChange: setTimeline,
    onContinue,
    onEdit,
  };
};
